import { render, staticRenderFns } from "./StepRelations.vue?vue&type=template&id=17084036&scoped=true"
import script from "./StepRelations.vue?vue&type=script&lang=js"
export * from "./StepRelations.vue?vue&type=script&lang=js"
import style0 from "./StepRelations.vue?vue&type=style&index=0&id=17084036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17084036",
  null
  
)

export default component.exports